<template>
    <div>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Referenciación, propuesta y aprobación de crédito
                </h6>
                <br>
                <h6 class="card-title text-center">
                    Referencias del titular
                </h6>
            </div>
            <div class="card-body">
                <div  class="alert alert-info text-center">
                    <span >Refencia familiar (De cualquier grado que no viva en la misma casa)</span>
                </div>
                <div class="form-group">
                    <label>Primer nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.first_name"
                                :error="getError('nombre referencia familiar')"
                                v-model="form.customer.familiar.first_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo/tercer nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="segundo nombre referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.second_first_name"
                                :error="getError('segundo nombre referencia familiar')"
                                v-model="form.customer.familiar.second_first_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Primer apellido</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="primer apellido referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.last_name"
                                :error="getError('primer apellido referencia familiar')"
                                v-model="form.customer.familiar.last_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo apellido</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="segundo apellido referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.second_last_name"
                                :error="getError('segundo apellido referencia familiar')"
                                v-model="form.customer.familiar.second_last_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Dirección domicilio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.home_address"
                                :error="getError('dirección referencia familiar')"
                                v-model="form.customer.familiar.home_address">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Ciudad/Municipio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="ciudad referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.home_city"
                                :error="getError('ciudad referencia familiar')"
                                v-model="form.customer.familiar.home_city">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Vínculo</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="vínculo referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.linkage"
                                :error="getError('vínculo referencia familiar')"
                                v-model="form.customer.familiar.linkage">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.phone1"
                                :error="getError('teléfono fijo referencia familiar')"
                                v-model="form.customer.familiar.phone1">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo 2 referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.phone2"
                                :error="getError('teléfono fijo 2 referencia familiar')"
                                v-model="form.customer.familiar.phone2">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Dirección oficina (Si aplica)</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección oficina referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.job_address"
                                :error="getError('dirección oficina referencia familiar')"
                                v-model="form.customer.familiar.job_address">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cargo</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="cargo referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.job"
                                :error="getError('cargo referencia familiar')"
                                v-model="form.customer.familiar.job">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono oficina</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono oficina referencia familiar"
                                autocomplete="off"
                                v-validate="modelValidations.customer.familiar.job_phone"
                                :error="getError('teléfono oficina referencia familiar')"
                                v-model="form.customer.familiar.job_phone">
                    </fg-input>
                </div>
                <div  class="alert alert-info text-center">
                    <span >Refencia personal</span>
                </div>
                <div class="form-group">
                    <label>Primer nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="primer nombre referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.first_name"
                                :error="getError('primer nombre referencia personal')"
                                v-model="form.customer.personal.first_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo/tercer nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="segundo nombre referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.second_first_name"
                                :error="getError('segundo nombre referencia personal')"
                                v-model="form.customer.personal.second_first_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Primer apellido</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="primer apellido referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.last_name"
                                :error="getError('primer apellido referencia personal')"
                                v-model="form.customer.personal.last_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo apellido</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="segundo apellido referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.second_last_name"
                                :error="getError('segundo apellido referencia personal')"
                                v-model="form.customer.personal.second_last_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Dirección domicilio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.home_address"
                                :error="getError('dirección referencia personal')"
                                v-model="form.customer.personal.home_address">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Ciudad/Municipio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="municipio referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.home_city"
                                :error="getError('municipio referencia personal')"
                                v-model="form.customer.personal.home_city">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Vínculo</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="vínculo referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.linkage"
                                :error="getError('vínculo referencia personal')"
                                v-model="form.customer.personal.linkage">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="telefono fijo referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.phone1"
                                :error="getError('telefono fijo referencia personal')"
                                v-model="form.customer.personal.phone1">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo 2 referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.phone2"
                                :error="getError('teléfono fijo 2 referencia personal')"
                                v-model="form.customer.personal.phone2">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Dirección oficina (Si aplica)</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección oficina referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.job_address"
                                :error="getError('dirección oficina referencia personal')"
                                v-model="form.customer.personal.job_address">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cargo</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="cargo referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.job"
                                :error="getError('cargo referencia personal')"
                                v-model="form.customer.personal.job">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono oficina</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono oficina referencia personal"
                                autocomplete="off"
                                v-validate="modelValidations.customer.personal.job_phone"
                                :error="getError('teléfono oficina referencia personal')"
                                v-model="form.customer.personal.job_phone">
                    </fg-input>
                </div>
                <div  class="alert alert-info text-center">
                    <span >Prospecto comercial</span>
                </div>
                <br>
                <h6 style="color: white;">
                    Prospecto 1
                </h6>
                <br>
                <div class="form-group">
                    <label>Nombre establecimiento o tipo de actividad</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre establecimiento"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[0].business_name"
                                :error="getError('nombre establecimiento')"
                                v-model="form.customer.comercial[0].business_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Nombres y apellidos prospecto</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombres prospecto"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[0].full_name"
                                :error="getError('nombres prospecto')"
                                v-model="form.customer.comercial[0].full_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Barrio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="barrio prospecto"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[0].neighborhood"
                                :error="getError('barrio prospecto')"
                                v-model="form.customer.comercial[0].neighborhood">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo/Celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo prospecto"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[0].phone1"
                                :error="getError('teléfono fijo prospecto')"
                                v-model="form.customer.comercial[0].phone1">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo/Celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo 2 prospecto"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[0].phone2"
                                :error="getError('teléfono fijo 2 prospecto')"
                                v-model="form.customer.comercial[0].phone2">
                    </fg-input>
                </div>
                <br> 
                <h6 style="color: white;">
                    Prospecto 2
                </h6>
                <br>
                <div class="form-group">
                    <label>Nombre establecimiento o tipo de actividad</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre establecimiento prospecto 2"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[1].business_name"
                                :error="getError('nombre establecimiento prospecto 2')"
                                v-model="form.customer.comercial[1].business_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Nombres y apellidos prospecto</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombres prospecto 2"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[1].full_name"
                                :error="getError('nombres prospecto 2')"
                                v-model="form.customer.comercial[1].full_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Barrio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="barrio prospecto 2"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[1].neighborhood"
                                :error="getError('barrio prospecto 2')"
                                v-model="form.customer.comercial[1].neighborhood">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo/Celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo prospecto 2"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[1].phone1"
                                :error="getError('teléfono fijo prospecto 2')"
                                v-model="form.customer.comercial[1].phone1">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo/Celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo 2 prospecto 2"
                                autocomplete="off"
                                v-validate="modelValidations.customer.comercial[1].phone2"
                                :error="getError('teléfono fijo 2 prospecto 2')"
                                v-model="form.customer.comercial[1].phone2">
                    </fg-input>
                </div>              
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                    <p-button @click="toMenu()" type="default" class="pull-left mb-3">Atrás</p-button>
                </div>
            </div>
        </card>
        <card v-if="validateGuarantors()" class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Referencia del codeudor
                </h6>
            </div>
            <div class="card-body">
                <div class="form-group">
                    <label>Primer nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="primer nombre referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.first_name"
                                :error="getError('primer nombre referencia codeudor')"
                                v-model="form.guarantor.reference.first_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo/tercer nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="segundo nombre referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.second_first_name"
                                :error="getError('segundo nombre referencia codeudor')"
                                v-model="form.guarantor.reference.second_first_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Primer apellido</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="primer apellido referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.last_name"
                                :error="getError('primer apellido referencia codeudor')"
                                v-model="form.guarantor.reference.last_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Segundo apellido</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="segundo apellido referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.second_last_name"
                                :error="getError('segundo apellido referencia codeudor')"
                                v-model="form.guarantor.reference.second_last_name">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Dirección domicilio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.home_address"
                                :error="getError('dirección referencia codeudor')"
                                v-model="form.guarantor.reference.home_address">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Ciudad/Municipio</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="municipio referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.home_city"
                                :error="getError('municipio referencia codeudor')"
                                v-model="form.guarantor.reference.home_city">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Vínculo</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="vínculo referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.linkage"
                                :error="getError('vínculo referencia codeudor')"
                                v-model="form.guarantor.reference.linkage">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.phone1"
                                :error="getError('teléfono fijo referencia codeudor')"
                                v-model="form.guarantor.reference.phone1">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono fijo celular</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono fijo 2 referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.phone2"
                                :error="getError('teléfono fijo 2 referencia codeudor')"
                                v-model="form.guarantor.reference.phone2">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Dirección oficina (Si aplica)</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="dirección oficina referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.job_address"
                                :error="getError('dirección oficina referencia codeudor')"
                                v-model="form.guarantor.reference.job_address">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cargo</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="cargo referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.job"
                                :error="getError('cargo referencia codeudor')"
                                v-model="form.guarantor.reference.job">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Teléfono oficina</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="teléfono oficina referencia codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.guarantor.reference.job_phone"
                                :error="getError('teléfono oficina referencia codeudor')"
                                v-model="form.guarantor.reference.job_phone">
                    </fg-input>
                </div>          
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                </div>
            </div>
        </card>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Evaluación socio ambiental
                </h6>
            </div>
            <div class="card-body">
                <div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.environment.rsa" :checked="false">Actividad dentro de la lista de inclusión RSA </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.environment.safety" :checked="false">Actividad sin condiciones mínimas de seguridad </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.environment.resources" :checked="false">Inadecuado manejo de recursos naturales </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.environment.toxicity" :checked="false">Inadecuado manejo de desechos tóxicos </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.environment.hard_work" :checked="false">Trabajo forzoso </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.environment.child" :checked="false">Explotación infantil</p-checkbox>
                    </div>
                </div>
                <div class="form-group">
                    <label>Observaciones</label>
                    <fg-input   tabindex="6"
                                type="text"
                                name="observaciones socioambientales"
                                autocomplete="off"
                                placeholder="Observaciones socioambientales"
                                v-validate="modelValidations.environment.observations"
                                :error="getError('observaciones socioambientales')"
                                v-model="form.environment.observations">
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                </div>
            </div>
        </card>
        <card class="form-horizontal">
            <div class="card-header">
                <h6 class="card-title text-center">
                    Propuesta del analista
                </h6>
            </div>
            <div class="card-body">
                <div  class="alert alert-info text-center">
                    <span >Propuesta de crédito</span>
                </div>
                <div class="form-group">
                    <label>Valor *</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="valor propuesta" v-validate="modelValidations.analyst_proposal.value" :error="getError('valor propuesta')" separator="." class="form-control" v-model="form.analyst_proposal.value"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Tipo cuota *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="tipo de cuota"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.type"
                                :error="getError('tipo de cuota')"
                                v-model="form.analyst_proposal.type">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label># Cuotas *</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="número de cuotas"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.payments_number"
                                :error="getError('número de cuotas')"
                                v-model="form.analyst_proposal.payments_number">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Cuota aprox</label>
                    <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="cuota aproximada" v-validate="modelValidations.analyst_proposal.payment_value" :error="getError('cuota aproximada')" separator="." class="form-control" v-model="form.analyst_proposal.payment_value"></vue-numeric>
                </div>
                <div class="form-group">
                    <label>Primer pago</label>
                    <el-date-picker
                        format="dd/MM/yyyy"
                        v-model="form.analyst_proposal.first_payment"
                        v-validate="modelValidations.analyst_proposal.first_payment"
                        type="date"
                        placeholder="Seleccione fecha">
                    </el-date-picker>
                </div>
                <div class="form-group">
                    <label>CIIU</label>
                    <fg-input   tabindex="1"
                                name="ciiu"
                                v-validate="modelValidations.analyst_proposal.ciiu"
                                :error="getError('ciiu')"
                                v-model="form.analyst_proposal.ciiu">
                            <el-select
                                    filterable
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione..."
                                    v-model="form.analyst_proposal.ciiu">
                            <el-option v-for="activity in $store.getters.getEconomicActivities" :key="activity.code"
                                    class="select-warning"
                                    :value="activity.code"
                                    :label="activity.code+' - '+activity.name">
                                    <span style="float: left">{{ activity.code }} - {{ activity.name }}</span>
                                    <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ activity.code }}</span> -->
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Descripción del Destino del Crédito </label>
                    <fg-input   tabindex="6"
                                type="text"
                                name="descripcion crédito"
                                autocomplete="off"
                                placeholder="describa el negocio"
                                v-validate="modelValidations.analyst_proposal.description_credit"
                                :error="getError('descripcion crédito')"
                                v-model="form.analyst_proposal.description_credit">
                    </fg-input>
                </div>
                <div  class="alert alert-info text-center">
                    <span >Tipo de garantías</span>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analyst_proposal.guarantee.pledge" value="1" :checked="false">Prendaria </p-checkbox>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analyst_proposal.guarantee.fng" value="1" :checked="false">FNG </p-checkbox>
                </div>
                <div v-if="form.analyst_proposal.guarantee.fng" class="form-group">
                    <label>EMP </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="emp"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.fng_emp"
                                :error="getError('emp')"
                                v-model="form.analyst_proposal.guarantee.fng_emp">
                    </fg-input>
                </div>
                <div v-if="form.analyst_proposal.guarantee.fng" class="form-group">
                   <div class="form-group">
                        <label>Ingreso por ventas al contado * 12</label>
                        <vue-numeric  :max=999999999999999 currency="$" autocomplete="off" name="ingresos" v-validate="modelValidations.analyst_proposal.guarantee.fng_incomes" :error="getError('ingresos')" separator="." class="form-control" v-model="form.analyst_proposal.guarantee.fng_incomes"></vue-numeric>
                    </div>
                </div>
                <div v-if="form.analyst_proposal.guarantee.fng" class="form-group">
                   <div class="form-group">
                        <label>Fecha de corte fiscal</label>
                        <el-date-picker
                            format="dd/MM/yyyy"
                            v-model="form.analyst_proposal.guarantee.fng_date"
                            type="date"
                            placeholder="Seleccione fecha de corte">
                        </el-date-picker>
                    </div>
                    <br>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analyst_proposal.guarantee.usaid" value="1" :checked="false">USAID </p-checkbox>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analyst_proposal.guarantee.vehicle" value="1" :checked="false">Vehículo </p-checkbox>
                </div>
                <div v-if="form.analyst_proposal.guarantee.vehicle" class="form-group">
                    <label>Tipo </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="tipo de vehículo"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.vehicle_type"
                                :error="getError('tipo de vehículo')"
                                v-model="form.analyst_proposal.guarantee.vehicle_type">
                    </fg-input>
                </div>
                <div v-if="form.analyst_proposal.guarantee.vehicle" class="form-group">
                    <label>Placa </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="placa vehículo"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.vehicle_plate"
                                :error="getError('placa vehículo')"
                                v-model="form.analyst_proposal.guarantee.vehicle_plate">
                    </fg-input>
                    <br>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analyst_proposal.guarantee.mortgage" value="1" :checked="false">Hipoteca </p-checkbox>
                </div>
                <div v-if="form.analyst_proposal.guarantee.mortgage" class="form-group">
                    <label>Nº matrícula inmobiliaria </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="matrícula inmobiliaria"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.mortgage_id"
                                :error="getError('matrícula inmobiliaria')"
                                v-model="form.analyst_proposal.guarantee.mortgage_id">
                    </fg-input>
                    <br>
                </div>
                <div class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analyst_proposal.guarantee.spouse" value="1" :checked="false">Cónyuge codeudor </p-checkbox>
                </div>
                <div v-if="form.analyst_proposal.guarantee.spouse" class="form-group">
                    <label>Nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.spouse_name"
                                :error="getError('nombre cónyuge')"
                                v-model="form.analyst_proposal.guarantee.spouse_name">
                    </fg-input>
                </div>
                <div v-if="form.analyst_proposal.guarantee.spouse" class="form-group">
                    <label>Nº. Identificación </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="identificación cónyuge"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.spouse_identification"
                                :error="getError('identificación cónyuge')"
                                v-model="form.analyst_proposal.guarantee.spouse_identification">
                    </fg-input>
                    <br>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analyst_proposal.guarantee.guarantor1" value="1" :checked="false">Codeudor 1</p-checkbox>
                </div>
                <div v-if="form.analyst_proposal.guarantee.guarantor1" class="form-group">
                    <label>Nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.guarantor1_name"
                                :error="getError('nombre codeudor')"
                                v-model="form.analyst_proposal.guarantee.guarantor1_name">
                    </fg-input>
                </div>
                <div v-if="form.analyst_proposal.guarantee.guarantor1" class="form-group">
                    <label>Nº. Identificación </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="identificación codeudor"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.guarantor1_identification"
                                :error="getError('identificación codeudor')"
                                v-model="form.analyst_proposal.guarantee.guarantor1_identification">
                    </fg-input>
                    <br>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analyst_proposal.guarantee.guarantor2" value="1" :checked="false">Codeudor 2</p-checkbox>
                </div>
                <div v-if="form.analyst_proposal.guarantee.guarantor2" class="form-group">
                    <label>Nombre</label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="nombre codeudor 2"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.guarantor2_name"
                                :error="getError('nombre codeudor 2')"
                                v-model="form.analyst_proposal.guarantee.guarantor2_name">
                    </fg-input>
                </div>
                <div v-if="form.analyst_proposal.guarantee.guarantor2" class="form-group">
                    <label>Nº. Identificación </label>
                    <fg-input   tabindex="1"
                                type="text"
                                name="identificación codeudor 2"
                                autocomplete="off"
                                v-validate="modelValidations.analyst_proposal.guarantee.guarantor2_identification"
                                :error="getError('identificación codeudor 2')"
                                v-model="form.analyst_proposal.guarantee.guarantor2_identification">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Retención de clientes / Inclusión financiera</label>
                    <fg-input   tabindex="3"
                                name="retención de clientes"
                                v-validate="modelValidations.analyst_proposal.guarantee.financial_inclusion"
                                :error="getError('retención de clientes')"
                                v-model="form.analyst_proposal.guarantee.financial_inclusion">
                            <el-select 
                                    v-model="form.analyst_proposal.guarantee.financial_inclusion"
                                    class="select-warning"
                                    size="large"
                                    placeholder="Seleccione">
                            <el-option class="select-warning"
                                    value = "1"
                                    label="SI">
                            </el-option>
                            <el-option class="select-warning"
                                    value = "2"
                                    label="NO">
                            </el-option>
                        </el-select>
                    </fg-input>
                </div>
                <div class="form-group">
                    <label>Observaciones</label>
                    <fg-input   tabindex="6"
                                type="text"
                                name="Observaciones"
                                autocomplete="off"
                                placeholder="Observaciones"
                                v-validate="modelValidations.analyst_proposal.guarantee.comments"
                                :error="getError('Observaciones')"
                                v-model="form.analyst_proposal.guarantee.comments">
                    </fg-input>
                </div>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="saveData()" type="warning">Guardar</p-button>
                </div>
            </div>
        </card>
        <card class="form-horizontal">
            <div class="card-header">
            </div>
            <div class="card-body">
                <h6 style="color:orange;" class="card-title-orange">Estabilidad</h6>
                <br>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <p class="statement">¿Cuánto tiempo tiene de experiencia en la actividad a financiar?</p>
                    </li>
                </ul>
                <br>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analysis.method1" value="1" :checked="false">Entre 12 y 18 meses </p-checkbox>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analysis.method2" value="1" :checked="false">Entre 18 y 24 meses </p-checkbox>
                </div>
                <div  class="row" style="margin: 0 0 12px;">
                    <p-checkbox v-model="form.analysis.method3" value="1" :checked="false"> 2 años </p-checkbox>
                </div>
                <br>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <p class="statement">ANÁLISIS DEL ENTORNO FAMILIAR: En escala de 1 a 5 (siendo 5 el mejor) cómo evalúa el entorno familiar del cliente de acuerdo con: tiempo y estabilidad de la relación conyugal, tipo de vivienda, organización del negocio y la unidad familiar, procedencia del cliente, créditos en la misma unidad familiar.</p>
                        <p class="switch">
                            <fg-input   tabindex="3"
                                    v-model="form.analysis.stability2">
                                    <el-select 
                                            v-model="form.analysis.stability2"
                                            class="select-warning"
                                            size="large"
                                            placeholder="1">
                                    <el-option class="select-warning"
                                            value = "1"
                                            label="1">
                                    </el-option>
                                    <el-option class="select-warning"
                                            value = "2"
                                            label="2">
                                    </el-option>
                                    <el-option class="select-warning"
                                            value = "3"
                                            label="3">
                                    </el-option>
                                    <el-option class="select-warning"
                                            value = "4"
                                            label="4">
                                    </el-option>
                                    <el-option class="select-warning"
                                            value = "5"
                                            label="5">
                                    </el-option>
                                </el-select>
                            </fg-input>
                        </p>
                    </li>
                </ul>
                <br>
                <h6 style="color:orange;" class="card-title-orange">Reputación</h6>
                <br>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <p class="statement">ANÁLISIS DEL ENTORNO SOCIAL: En escala de 1 a 5  (siendo 5 el mejor) cómo evalúa el entorno social del cliente de acuerdo con: verificación de referencias zonales, familiares, comerciles, grado de reconocimiento, reputación en la zona, nivel responsabilidad.</p>
                        <p class="switch">
                            <fg-input   tabindex="3"
                                v-model="form.analysis.reputation1">
                                <el-select 
                                        v-model="form.analysis.reputation1"
                                        class="select-warning"
                                        size="large"
                                        placeholder="1">
                                <el-option class="select-warning"
                                        value = "1"
                                        label="1">
                                </el-option>
                                <el-option class="select-warning"
                                        value = "2"
                                        label="2">
                                </el-option>
                                <el-option class="select-warning"
                                        value = "3"
                                        label="3">
                                </el-option>
                                <el-option class="select-warning"
                                        value = "4"
                                        label="4">
                                </el-option>
                                <el-option class="select-warning"
                                        value = "5"
                                        label="5">
                                </el-option>
                            </el-select>
                        </fg-input>
                        </p>
                    </li>
                </ul>
                <br>
                <h6 style="color:orange;" class="card-title-orange">Reponsabilidad en pagos</h6>
                <br>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <p class="statement">¿Tiene endeudamiento informal con particulares o familiares?</p>
                        <p class="switch">
                            <p-switch type="warning" v-model="form.analysis.responsabilityPayments1">
                                <i class="fa fa-check" slot="on"></i>
                                <i class="fa fa-times" slot="off"></i>
                            </p-switch>
                        </p>
                    </li>
                </ul>
                <br>
                <h6 style="color:orange;" class="card-title-orange">Habilidad empresarial</h6>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        <p class="statement">¿Cuenta con otros ingresos que le permitan cubrir su obligación crediticia? Si la respuesta es positiva especificar cuál:</p>
                        <p class="switch">
                            <p-switch type="warning" v-model="form.analysis.businessAbility1">
                                <i class="fa fa-check" slot="on"></i>
                                <i class="fa fa-times" slot="off"></i>
                            </p-switch>
                        </p>
                    </li>
                    <br>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.analysis.businessAbility1Job" value="1" :checked="false">Empleo/Pensión </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.analysis.businessAbility1FamilyHelp" value="1" :checked="false">Ayuda familiar </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.analysis.businessAbility1Lease" value="1" :checked="false">Arrendamiento </p-checkbox>
                    </div>
                    <div  class="row" style="margin: 0 0 12px;">
                        <p-checkbox v-model="form.analysis.businessAbility1Other" value="1" :checked="false">Otra actividad </p-checkbox>
                    </div>
                </ul>
                <br>
            </div>
            <div class="card-footer">
                <div class="text-right">
                    <p-button @click="finishData()" type="warning">Finalizar</p-button>
                </div>
            </div>
        </card>
    </div>
</template>
    <script>
    import fab from 'vue-fab'
    import { Card } from 'src/components/UIComponents'
    import Vue from 'vue'
    import {Select, Option , DatePicker, TimeSelect} from 'element-ui'
    import VueNumeric from 'vue-numeric'
    import formatMoney from 'accounting-js/lib/formatMoney.js'
    import moment from 'moment'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import { parse } from 'expression-eval'
    import { isEmpty } from 'lodash';
    import swal from 'sweetalert2'
    Vue.use(Select)
    Vue.use(Option)
    export default {
        components: {
            Card,
            VueNumeric,
            PSwitch,
            fab,
            [DatePicker.name]: DatePicker,
            [TimeSelect.name]: TimeSelect,
        },
        data() {
        return {
            pyme: false,
            maxQuotaPyme: null,
            method1: false,
            method2: false,
            method3: false,
            bgColor: '#F09500',
            position: 'bottom-right',
            position2: 'top-right',
            fabActions: [
                {
                    name: 'toER',
                    icon: 'ER'
                }
            ],
            testModel: false,
            customerFirstName: '',
            customerStudyDescription: '',
            form: {
                finished: false,
                customer: {
                    familiar: {
                        first_name: '',
                        second_first_name: '',
                        last_name: '',
                        second_last_name: '',
                        home_address: '',
                        home_state: '',
                        home_city: '',
                        linkage: '',
                        phone1: '',
                        phone2: '',
                        job_address: '',
                        job: '',
                        job_phone: '',
                    },
                    personal: {
                        first_name: '',
                        second_first_name: '',
                        last_name: '',
                        second_last_name: '',
                        home_address: '',
                        home_state: '',
                        home_city: '',
                        linkage: '',
                        phone1: '',
                        phone2: '',
                        job_address: '',
                        job: '',
                        job_phone: '',
                    },
                    comercial: [
                        {
                            business_name: '',
                            full_name: '',
                            neighborhood: '',
                            phone1: '',
                            phone2: '',
                        },
                        {
                            business_name: '',
                            full_name: '',
                            neighborhood: '',
                            phone1: '',
                            phone2: '',
                        }
                    ]
                },
                guarantor: {
                    reference: {
                        first_name: '',
                        second_first_name: '',
                        last_name: '',
                        second_last_name: '',
                        home_address: '',
                        home_state: '',
                        home_city: '',
                        linkage: '',
                        phone1: '',
                        phone2: '',
                        job_address: '',
                        job: '',
                        job_phone: '',
                    }
                },
                environment: {
                    rsa: false,
                    safety: false,
                    resources: false,
                    toxicity: false,
                    hard_work: false,
                    child: false,
                    observations: ''
                },
                analyst_proposal: {
                    debt: null,
                    credit_purpose: null,
                    value: '',
                    type: '',
                    payments_number: '',
                    payment_value: '',
                    first_payment: Date.now(),
                    ciiu: '',
                    description_credit: '',
                    guarantee: {
                        pledge: false,
                        fng: false,
                        fng_emp: '',
                        fng_incomes: '',
                        fng_date: null,
                        usaid: false,
                        vehicle: false,
                        vehicle_type: '',
                        vehicle_plate: '',
                        mortgage: false,
                        mortgage_id: '',
                        spouse: false,
                        spouse_name: '',
                        spouse_identification: '',
                        guarantor1: false,
                        guarantor1_name: '',
                        guarantor1_identification: '',
                        guarantor2: false,
                        guarantor2_name: '',
                        guarantor2_identification: '',
                        financial_inclusion: '',
                        comments: ''
                    }
                },
                analysis: {
                    method1: false,
                    method2: false,
                    method3: false,
                    stability1: 'A',
                    stability2: '1',
                    reputation1: '1',
                    responsabilityPayments1: false,
                    businessAbility1: false,
                    businessAbility1Job: false,
                    businessAbility1FamilyHelp: false,
                    businessAbility1Lease: false,
                    businessAbility1Other: false,
                },
            },
            modelValidations: {
                customer: {
                    familiar: {
                        first_name: {
                            required: true,
                            max: 32
                        },
                        second_first_name: {
                            required: false,
                            max: 32
                        },
                        last_name: {
                            required: true,
                            max: 32
                        },
                        second_last_name: {
                            required: false,
                            max: 32
                        },
                        home_address: {
                            required: true,
                            max: 32
                        },
                        home_state: {
                            required: false,
                            max: 32
                        },
                        home_city: {
                            required: true,
                            max: 32
                        },
                        linkage: {
                            required: true,
                            max: 32
                        },
                        phone1: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                        phone2: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                        job_address: {
                            required: false,
                            max: 120
                        },
                        job: {
                            required: false,
                            max: 32
                        },
                        job_phone: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                    },
                    personal: {
                        first_name: {
                            required: true,
                            max: 32
                        },
                        second_first_name: {
                            required: false,
                            max: 32
                        },
                        last_name: {
                            required: true,
                            max: 32
                        },
                        second_last_name: {
                            required: false,
                            max: 32
                        },
                        home_address: {
                            required: true,
                            max: 120
                        },
                        home_state: {
                            required: false,
                            max: 32
                        },
                        home_city: {
                            required: true,
                            max: 32
                        },
                        linkage: {
                            required: true,
                            max: 32
                        },
                        phone1: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                        phone2: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                        job_address: {
                            required: false,
                            max: 120
                        },
                        job: {
                            required: false,
                            max: 32
                        },
                        job_phone: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                    },
                    comercial: [
                        {
                            business_name: {
                                required: true,
                                max: 32
                            },
                            full_name: {
                                required: true,
                                max: 32
                            },
                            neighborhood: {
                                required: false,
                                max: 32
                            },
                            phone1: {
                                required: true,
                                numeric: true,
                                max: 32
                            },
                            phone2: {
                                required: false,
                                numeric: true,
                                max: 32
                            },
                        },
                        {
                            business_name: {
                                required: false,
                                max: 32
                            },
                            full_name: {
                                required: false,
                                max: 32
                            },
                            neighborhood: {
                                required: false,
                                max: 32
                            },
                            phone1: {
                                required: false,
                                numeric: true,
                                max: 32
                            },
                            phone2: {
                                required: false,
                                numeric: true,
                                max: 32
                            },
                        }
                    ]
                },
                guarantor: {
                    reference: {
                        first_name: {
                            required: false,
                            max: 32
                        },
                        second_first_name: {
                            required: false,
                            max: 32
                        },
                        last_name: {
                            required: false,
                            max: 32
                        },
                        second_last_name: {
                            required: false,
                            max: 32
                        },
                        home_address: {
                            required: false,
                            max: 120
                        },
                        home_state: {
                            required: false,
                            max: 32
                        },
                        home_city: {
                            required: false,
                            max: 32
                        },
                        linkage: {
                            required: false,
                            max: 32
                        },
                        phone1: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                        phone2: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                        job_address: {
                            required: false,
                            max: 120
                        },
                        job: {
                            required: false,
                            max: 32
                        },
                        job_phone: {
                            required: false,
                            numeric: true,
                            max: 32
                        },
                    }
                },
                environment: {
                    rsa: {
                        required: false
                    },
                    safety: {
                        required: false
                    },
                    resources: {
                        required: false
                    },
                    toxicity: {
                        required: false
                    },
                    hard_work: {
                        required: false
                    },
                    child: {
                        required: false
                    },
                    observations: {
                        required: false,
                        max: 64
                    }
                },
                analyst_proposal: {
                    value: {
                        required: true,
                        max: 32
                    },
                    type: {
                        required: true,
                        max: 32
                    },
                    payments_number: {
                        required: true,
                        numeric: true,
                        max: 32
                    },
                    payment_value: {
                        required: true,
                        max: 32
                    },
                    first_payment: {
                        required: false
                    },
                    ciiu: {
                        required: false,
                        max: 12
                    },
                    description_credit: {
                        required: true,
                        max: 260
                    },
                    guarantee: {
                        pledge: {
                            required: false
                        },
                        fng: {
                            required: false
                        },
                        fng_emp: {
                            required: false,
                            max:12
                        },
                        fng_incomes: {
                            required: false
                        },
                        fng_date: {
                            required: false
                        },
                        usaid: {
                            required: false
                        },
                        vehicle: {
                            required: false
                        },
                        vehicle_type: {
                            required: false,
                            max: 32
                        },
                        vehicle_plate: {
                            required: false,
                            max: 32
                        },
                        mortgage: false,
                        mortgage_id: {
                            required: false,
                            max: 32
                        },
                        spouse: false,
                        spouse_name: {
                            required: false,
                            max: 32
                        },
                        spouse_identification: {
                            required: false,
                            numeric: true
                        },
                        guarantor1: false,
                        guarantor1_name: {
                            required: false,
                            max: 32
                        },
                        guarantor1_identification: {
                            required: false,
                            numeric: true
                        },
                        guarantor2: false,
                        guarantor2_name: {
                            required: false,
                            max: 32
                        },
                        guarantor2_identification: {
                            required: false,
                            numeric: true
                        },
                        financial_inclusion: {
                            required: false,
                            max: 32
                        },
                        comments: {
                            required: false,
                            max: 220
                        },
                    }
                }
            },
            modelValidations2: {
                username: {
                    alpha_dash: true,
                    required: true,
                    max: 32
                },
                customerStudyDescription: {
                    required: false, 
                    max: 256
                },
                requestDataAmount: {
                    required: true,
                },
                customerSalary: {
                    required: true
                },
                requestData: {
                    required: true
                }
            },
        }
        },
        watch: {
            'form.analysis.method1': function(newVal, oldVal) {
                if(newVal) {
                    this.form.analysis.stability1 = 'A';
                    this.form.analysis.method2 = false;
                    this.form.analysis.method3 = false;
                }
            },
            'form.analysis.method2': function(newVal, oldVal) {
                if(newVal) {
                    this.form.analysis.stability1 = 'B';
                    this.form.analysis.method1 = false;
                    this.form.analysis.method3 = false;
                }
            },
            'form.analysis.method3': function(newVal, oldVal) {
                if(newVal) {
                    this.form.analysis.stability1 = 'C';
                    this.form.analysis.method1 = false;
                    this.form.analysis.method2 = false;
                }
            },
            'form.analyst_proposal.guarantee.fng': function(newVal, oldVal) {
                if(!newVal && oldVal) {
                    this.form.analyst_proposal.guarantee.fng_emp = '';
                    this.form.analyst_proposal.guarantee.fng_incomes = '';
                    this.form.analyst_proposal.guarantee.fng_date = null;
                }
            },
            'form.analyst_proposal.guarantee.vehicle': function(newVal, oldVal) {
                if(!newVal && oldVal) {
                    this.form.analyst_proposal.guarantee.vehicle_type = '';
                    this.form.analyst_proposal.guarantee.vehicle_plate = '';
                }
            },
            'form.analyst_proposal.guarantee.mortgage': function(newVal, oldVal) {
                if(!newVal && oldVal) {
                    this.form.analyst_proposal.guarantee.mortgage_id = '';
                }
            },
            'form.analyst_proposal.guarantee.spouse': function(newVal, oldVal) {
                if(!newVal && oldVal) {
                    this.form.analyst_proposal.guarantee.spouse_name = '';
                    this.form.analyst_proposal.guarantee.spouse_identification = '';
                }
            },
            'form.analyst_proposal.guarantee.guarantor1': function(newVal, oldVal) {
                if(!newVal && oldVal) {
                    this.form.analyst_proposal.guarantee.guarantor1_name = '';
                    this.form.analyst_proposal.guarantee.guarantor1_identification = '';
                }
            },
            'form.analyst_proposal.guarantee.guarantor2': function(newVal, oldVal) {
                if(!newVal && oldVal) {
                    this.form.analyst_proposal.guarantee.guarantor2_name = '';
                    this.form.analyst_proposal.guarantee.guarantor2_identification = '';
                }
            },
            'form.analyst_proposal.payment_value' : function(newVal){
                if(newVal != ''){
                    if(parseFloat(newVal) > parseFloat(this.maxQuotaPyme)){
                        swal({
                            title: 'Atención',
                            // text: 'Si aceptas, agregarás un codeudor a la evaluación',
                            text: `El valor máximo a de la cuota aproximada debe ser de ${this.setFormat(this.maxQuotaPyme)} y se está registrando  ${this.setFormat(newVal)}, corrige y continua`,
                            type: 'info',
                            showCancelButton: false,
                            confirmButtonText: 'Continuar',
                            confirmButtonClass: 'btn btn-success btn-fill',
                            buttonsStyling: false
                        });
                        // Establecer el valor de 'clientterm' en null
                        this.form.analyst_proposal.payment_value = '';
                    }
                }
            }
        },
        computed: {
            
        },
        methods: {
            setPaymentCapacity() {
                // Inicializar valores
                let firstQuota = 0;
                let consolidatedQuota = 0;

                // Validar que exista `actualAssesment` en el estado
                if (this.$store.state.assesments && this.$store.state.actualAssesment !== undefined) {
                    const actualAssessment = this.$store.state.assesments[this.$store.state.actualAssesment];
                    // Validar la existencia de `customer`, `studies` y `actualStudy`
                    if (
                        actualAssessment &&
                        actualAssessment.customer &&
                        actualAssessment.customer.studies &&
                        actualAssessment.customer.actualStudy !== undefined
                    ) {
                        const customer = actualAssessment.customer;
                        const actualStudy = customer.studies[customer.actualStudy];
                        
                        // Validar la existencia de `balance` y procesarlo
                        if (actualStudy && actualStudy.balance && actualStudy.balance.length > 0) {
                            const storagePaymentCapacity = actualStudy.balance[0].cp && actualStudy.balance[0].cp.paymentCapacity;
                            if (storagePaymentCapacity && Array.isArray(storagePaymentCapacity)) {
                                for (let i = 0; i < storagePaymentCapacity.length; i++) {
                                    if (this.pyme && storagePaymentCapacity[i].name === 'Capacidad de pago (75%)') {
                                        firstQuota = storagePaymentCapacity[i].value;
                                    }
                                }
                            }
                        }
                    }
                    
                    // Validar la existencia de `customerBalanceConsolidated` y procesarlo
                    if (actualAssessment.customerBalanceConsolidated && typeof actualAssessment.customerBalanceConsolidated === 'object') {
                        const customerBalanceConsolidated = actualAssessment.customerBalanceConsolidated;
                        // Aquí podrías acceder a las propiedades de customerBalanceConsolidated, como indebtness o debt
                        const storagePaymentCapacity = customerBalanceConsolidated.cp && customerBalanceConsolidated.cp.paymentCapacity;
                        if (storagePaymentCapacity && Array.isArray(storagePaymentCapacity)) {
                            for (let i = 0; i < storagePaymentCapacity.length; i++) {
                                if (this.pyme && storagePaymentCapacity[i].name === 'Capacidad de pago (75%)') {
                                    consolidatedQuota = storagePaymentCapacity[i].value;
                                }
                            }
                        }
                    }
                }

                // Calcular el máximo entre `firstQuota` y `consolidatedQuota`
                this.maxQuotaPyme = Math.round(Math.max(firstQuota, consolidatedQuota));
            },


            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             setFormat (value) {
                return formatMoney(value, { symbol: "$", precision: 0, thousand: ".", decimal: "," });
            },
            validateGuarantors () {
                if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors.length > 0) {
                    return true
                }
                else if (this.$store.state.assesments[this.$store.state.actualAssesment].guarantors.length == 0) {
                    this.form.guarantor.reference.first_name= '';
                    this.form.guarantor.reference.second_first_name= '';
                    this.form.guarantor.reference.last_name= '';
                    this.form.guarantor.reference.second_last_name= '';
                    this.form.guarantor.reference.home_address= '';
                    this.form.guarantor.reference.home_state= '';
                    this.form.guarantor.reference.home_city= '';
                    this.form.guarantor.reference.linkage= '';
                    this.form.guarantor.reference.phone1= '';
                    this.form.guarantor.reference.phone2= '';
                    this.form.guarantor.reference.job_address= '';
                    this.form.guarantor.reference.job= '';
                    this.form.guarantor.reference.job_phone= '';
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toMenu () {
                this.$router.push('/asessments/menu');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toFM100() {
                this.$router.push('/asessments/new_asessment/customer/fm100');
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toER () {

            },
            
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            productValidator (product) {
                if (product.name.toLowerCase() == 'pequeña empresa') {
                    this.pyme = true;
                    this.setPaymentCapacity();
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             agroValidator (product) {
                if(product.name.toLowerCase() == 'agropecuario') {
                    if (this.$store.state.isCustomer) {
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow) {
                            this.form.analyst_proposal.first_payment = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].agroData.cashFlow.firstPaymentDate;
                        }
                    }
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función para mostrar un mensaje de éxito
            */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            saveData () {
                this.form.finished = false;
                this.$store.dispatch('setFM102', this.$data).then(()=>{
                    this.showNotificationSuccess('Información guardada correctamente en el dispositivo')
                });
            },
            finishData () {
                this.form.finished = false;
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        // if (this.form.analyst_proposal.value == 0) {
                        //     this.showNotificationError('El valor de la propuesta de crédito no puede ser 0');
                        //     return
                        // }
                        // if (this.form.analyst_proposal.payment_value == 0) {
                        //     this.showNotificationError('El valor de cuota de la propuesta de crédito no puede ser 0');
                        //     return
                        // }
                        this.form.finished = true;
                        this.$store.dispatch('setFM102', this.$data).then(()=>{
                            var payload = {
                                stage: 'Registro de Formulario',
                                description: 'Se ingresan datos del formulario FM102.',
                                dateTime: moment().format()
                            };
                            this.$store.dispatch('setChangeLog', payload).then(()=>{
                                this.$router.push('/asessments/menu');
                            });
                        });
                    }
                    else {
                        this.showNotificationError('Algunos campos son erróneos, revisa y continúa');
                        // window.scroll(0, 0);
                        this.$el.querySelector('[name="' + this.$validator.errors.items[0].field + '"]').focus();
                    }
                })
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            toSalesCostsSelection () {
                this.$validator.validateAll().then(isValid => {
                    if(isValid){
                        if (this.$store.state.assesments[this.$store.state.actualAssesment].amount == 0) {
                            this.showNotificationError('El monto a solicitar no puede ser 0');
                            return
                        }
                        var subcategory = this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[this.$store.state.assesments[this.$store.state.actualAssesment].customer.actualStudy].studySubcategory;
                        var payload = {
                            stage: 'Ingreso de datos de negocio',
                            description: 'Se ingresan los datos del negocio.',
                            dateTime: moment().format()
                        };
                        this.$store.dispatch('setChangeLog', payload).then(()=>{
                            if (this.microcredit) {
                                if (subcategory == 'catalogo') {
                                    this.$router.push('/asessments/new_asessment/customer/costs/business/catalog');
                                }
                                else {
                                    this.$router.push('/asessments/new_asessment/customer/sales_costs_selection');    
                                }
                            }
                            else if(this.consumer) {
                                this.$router.push('/asessments/new_asessment/customer/others/business_references');
                            }
                            
                        });
                    }
                    else {
                        this.showNotificationError('El formulario no está completo');
                    }
                })
                
                
            }
        },
        mounted() {
            var product = this.$store.getters.getProductTypes.find(product => product.id == this.$store.state.assesments[this.$store.state.actualAssesment].customer.studies[0].productType)
            this.productValidator(product);
            if(this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm102.length > 0) {
                // this.$data.form = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm102[0];
                var form = JSON.parse(JSON.stringify(this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm102[0]));
                this.$data.form = form;
                this.form.analyst_proposal.guarantee = this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm102[0].analyst_proposal.guarantee;
                // console.info(this.$store.state.assesments[this.$store.state.actualAssesment].customer.fm102[0]);
                // console.info(this.form);
            }
            if (this.$store.state.assesments[this.$store.state.actualAssesment].hasOwnProperty('customerSpouse') && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies.length > 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName != null && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.finished == true && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].balance.length != 0 && this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.studies[0].references.length != 0) {
                this.form.analyst_proposal.guarantee.spouse = true;
                this.form.analyst_proposal.guarantee.spouse_name = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerFirstName+' '+(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSecondName || '')+' '+this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSurname+' '+(this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerSecondSurname || '');
                this.form.analyst_proposal.guarantee.spouse_identification  = this.$store.state.assesments[this.$store.state.actualAssesment].customerSpouse.customerIdentificationNumber;    
            }
            if(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors.length > 0) {
                this.form.analyst_proposal.guarantee.guarantor1 = true;
                this.form.analyst_proposal.guarantee.guarantor1_name = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerFirstName+' '+(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerSecondName || '')+' '+this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerSurname+' '+(this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerSecondSurname || '');
                this.form.analyst_proposal.guarantee.guarantor1_identification = this.$store.state.assesments[this.$store.state.actualAssesment].guarantors[0].customerIdentificationNumber;
            }
            this.agroValidator(product);
        }
    }
</script>
<style>
.fab-main .material-icons{
    color: black !important;
    background-color: #F09500 !important;
}
.fab-list li .material-icons{
    color: black !important;
    font-family: "Helvetica Neue" !important;
    font-size: 12px !important;
}
.center-title {
        margin-top: 0;
        margin-bottom: 0;
    }
.orange {
    color: #F09500;
}
.white {
    color: white;
}
</style>
